import React from 'react';

if (process.browser) require('./Body.scss');

export default function Body({ children }) {
  return (
    <div className="with-container body">
      { children }
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/Body/Body.js